import {TagApi} from "./tag_api";
import {Collapse, Space, Typography} from "antd";
import React from "react";
import CollapsePanel from "antd/es/collapse/CollapsePanel";

export const GetApiCollapsePanel = ({children, name, descriptions}) => {

    return (
        <Collapse style={{border:'0', marginBottom:'10pt'}}>
            <CollapsePanel key={1} style={{backgroundColor: '#ecf3fa', border:'1pt solid #b0d0f8'}} header={
                <>
                    <Space>
                        <TagApi color={'white'} backgroundColor={'#77aff5'}>GET</TagApi>
                        <Typography.Text
                            style={{
                                fontFamily: 'monospace',
                                fontWeight: 'bold',
                                fontSize: 'large'
                            }}>
                            /{name}
                            <span style={{
                                marginLeft:'10pt',
                                fontWeight: 'normal',
                                color:'gray',
                                fontFamily:'Montserrat-Regular, serif',
                                fontSize: 'small'
                            }}>
                            {descriptions}
                        </span>
                        </Typography.Text>
                    </Space>
                </>
            }
            >
                {children}
            </CollapsePanel>
        </Collapse>
    )
}